const TOKEN_PROPERTIES = {
    OAUTH_STORAGE_KEY: 'oAuth2',
    OAUTH_EXPIRE_KEY_IN_STORAGE: 'oAuth2.expireIn',
    OAUTH_LAST_REFRESH_TOKEN_TIMESTAMP: 'oAuth2.lastLoginTimeStamp',
    OAUTH_LAST_USER_DATA: 'oAuth2.userData',
    OAUTH_LAST_SESSION_DATA: 'oAuth2.lastSession',
    OAUTH_HAS_REMEMBER_ME: 'oAuth2.hasRememberMe',
    OAUTH_LAST_TIME_ACTIVITY: 'oAuth2.lastTimeActivity',
    OAUTH_CUSTOM_SESSION_TIMEOUT: 'oAuth2.customSessionTimeout',
    OAUTH_ACCESS_TOKEN: 'oAuth2.access_token',
    OAUTH_TOKEN_FIELDS_OVERRIDES: 'oAuth2.tokenFieldsOverrides',
};
const GRANT_TYPES = {
    PASSWORD: 'password',
    REFRESH_TOKEN: 'refresh_token',
    AUTOLOGIN: 'autologin'
};
const OAUTH2_CSS = {
    AUTHORIZED_USER_CLASS: 'cgp-authorized-user'
};

const HTTP = {
    OK: 200
};
const OAUTH_TOKEN_ERRORS = {
    INVALID_GRANT: 'invalid_grant'
};
const LOGIN_TYPE = {
    NEW_LOGIN: 1,
    AUTOLOGIN: 3
};

const ID_VERIFICATION_STATUS = {
    AGE_VERIFIED: 1,
    ADDRESS_VERIFIDED: 1
};

const LOGOUT_REASONS = {
    EXPLICIT_LOGOUT: 1,
    USER_IDLE: 2,
    AUTOLOGIN_FAILED: 3,
    REFRESH_TOKEN_FAILED: 4,
    ACCESS_TOKEN_REMOVED: 5,
    USER_KICKED: 6,
};

export { TOKEN_PROPERTIES, HTTP, GRANT_TYPES, OAUTH2_CSS, OAUTH_TOKEN_ERRORS, LOGIN_TYPE, ID_VERIFICATION_STATUS, LOGOUT_REASONS };


